export class GenCountryCustomerEntity{
    id:number;
    countryId:number;
    country:string;
    customerId:number;
    customer:string;

    constructor(){}
}